export const sorts = {
  default: ['-lifetime_gmv'],
  options: [
    {
      name: 'Links',
      key: 'links',
      options: [{ key: '-lifetime_links', value: 'Most' }, { key: 'lifetime_links', value: 'Least' }]
    },
    {
      name: 'Clicks',
      key: 'lifetime_clicks',
      options: [{ key: '-lifetime_clicks', value: 'Most' }, { key: 'lifetime_clicks', value: 'Least' }]
    },
    {
      name: 'Sales',
      key: 'lifetime_gmv',
      options: [{ key: '-lifetime_gmv', value: 'Most' }, { key: 'lifetime_gmv', value: 'Least' }]
    },
    {
      name: 'Last link shared',
      key: 'last_link_shared',
      options: [{ key: '-last_link_shared', value: 'Most' }, { key: 'last_link_shared', value: 'Least' }]
    }
  ]
};